import {
  faChevronRight,
  faChevronDown,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';

export const ExpandButton = ({
  value,
  matchesGridBreakpoint,
  onClick,
}: {
  value: boolean;
  matchesGridBreakpoint: boolean;
  onClick: () => void;
}) => (
  <Button
    onClick={onClick}
    aria-expanded={value}
    aria-label={
      !matchesGridBreakpoint ? (value ? 'Collapse' : 'Expand') : void 0
    }>
    {value ? 'Collapse' : 'Expand'}
    <FontAwesomeIcon
      icon={value ? faChevronDown : faChevronRight}
      size="1x"
      fixedWidth
    />
  </Button>
);
